import styled from 'styled-components'

export const LeftArrow = styled.button`
  svg {
    width: 100%;
    height: 100%;
    stroke-width: 4px;
    transform: rotate(180deg);

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      stroke-width: 1px;
    }
  }
`

export const RightArrow = styled.button`
  svg {
    width: 100%;
    height: 100%;
    stroke-width: 4px;

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      stroke-width: 1px;
    }
  }
`

export const MobileBannerArrow = styled.svg`
  display: none;
  position: absolute;
  width: 42px;
  height: 15px;
  bottom: 2.4rem;
  color: ${props => props.theme.colors.white};
  left: 50%;
  transform: translateX(-50%);
`

export const CarouselWrapper = styled.section`
  position: relative;
  height: ${props => (props.fillScreen ? '100vh' : '54rem')};

  &:first-of-type {
    margin-top: -10rem;
    min-height: 630px;

    h2 {
      font-size: 3.4rem;

      @media screen and (min-width: ${props => props.theme.responsive.large}) {
        font-size: 6.4rem;
      }
    }

    ${MobileBannerArrow} {
      display: block;

      @media screen and (min-width: ${props => props.theme.responsive.medium}) {
        display: none;
      }
    }

    .slick-dots {
      bottom: 6.4rem;

      @media screen and (min-width: ${props => props.theme.responsive.medium}) {
        bottom: 3rem;
      }
    }
  }

  h2 {
    font-size: 2.8rem;

    @media screen and (min-width: ${props => props.theme.responsive.large}) {
      font-size: 4rem;
    }
  }

  .slick-dots {
    bottom: 2rem;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      width: 100%;
      text-align: center;
    }

    li {
      cursor: auto;
      width: auto;
      height: 2px;

      button {
        display: inline-block;
        width: 5.2rem;
        /* To increase clickable area of the position indicators */
        padding: 3rem 0;
        margin: -3rem 0;

        &:before {
          content: '';
          opacity: 1;
          width: 5.2rem;
          border: 1px solid ${props => props.theme.colors.lightGrey};
          height: 1px;
        }

        @media screen and (min-width: ${props =>
    props.theme.responsive.small}) {
          margin-right: 1.5rem;
          width: 6.1rem;

          &::before {
            width: 6.1rem;
          }
        }
      }

      &.slick-active {
        button {
          &:before {
            border: 1px solid ${props => props.theme.colors.cobalt};
          }
        }
      }
    }

    button {
      width: 100%;
      height: auto;
      padding: 0;
    }
  }

  ${LeftArrow},
  ${RightArrow} {
    position: absolute;
    width: 24px;
    height: 24px;
    color: ${props => props.theme.colors.white};
    top: 50%;
    z-index: 1;
    cursor: pointer;

    &::before {
      content: '';
    }

    &:hover,
    &:focus {
      color: ${props => props.theme.colors.white};
    }

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      width: 32px;
      height: 32px;
    }

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      width: 48px;
      height: 48px;
    }
  }

  ${LeftArrow} {
    left: 2rem;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      left: 3rem;
    }

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      left: 5rem;
    }
  }

  ${RightArrow} {
    right: 2rem;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      right: 3rem;
    }

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      right: 5rem;
    }
  }
`
